import React, { FC, useEffect, useRef } from 'react';

import { IEnvelopeProps as IProps } from '@views/envelopes/types';

import EnvelopeCheckbox from './EnvelopeCheckbox';
import EnvelopeSubject from './EnvelopeSubject';
import EnvelopeStatus from './EnvelopeStatus';
import EnvelopLastChange from './EnvelopeLastChange';
import EnvelopeActions from './EnvelopeActions';
import EnvelopeIcons from '@views/envelopes/components/EnvelopesTable/EnvelopeItem/EnvelopeIcons';
import { useParams } from 'react-router';
import { useAppSelector } from '@app/hooks/redux';

const EnvelopeItem: FC<IProps> = ({ envelope, checkbox, selectedCheckbox, idx, onOpenDeclineModal }) => {
  const {
    oguid,
    directions,
    allowedActions,
    subject,
    recipients,
    flowState,
    taskCompletedCount,
    taskTotalCount,
    lastActionDateTime,
  } = envelope

  const { directionOrFolder, boxOguid } = useParams();

  const personalBoxOguid = useAppSelector((state) => state.user.profile.boxOguid);

  const currentBoxOguid = boxOguid || personalBoxOguid;

  const trRef = useRef<HTMLTableRowElement>(null);

  useEffect(() => {
    if (idx === 0) {
      trRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
        // inline: "start",
      });
    }
  }, [idx, directionOrFolder]);

  return (
    <tr ref={trRef}>
      <EnvelopeCheckbox
        oguid={oguid}
        checkbox={checkbox}
        selectedCheckbox={selectedCheckbox}
      />
      <EnvelopeIcons
        directions={directions}
        allowedActions={allowedActions}
      />
      <EnvelopeSubject
        subject={subject}
        recipients={recipients}
        oguid={oguid}
        boxOguid={currentBoxOguid}
      />
      <EnvelopeStatus
        flowState={flowState}
        taskCompletedCount={taskCompletedCount}
        taskTotalCount={taskTotalCount}
      />
      <EnvelopLastChange
        lastActionDateTime={lastActionDateTime}
      />
      <EnvelopeActions
        oguid={oguid}
        allowedActions={allowedActions}
        subject={subject}
        boxOguid={currentBoxOguid}
        onOpenDeclineModal={onOpenDeclineModal}
      />
    </tr>
  )
}

export default EnvelopeItem
